import classnames from "classnames"

type TextColor =
  | "brand"
  | "tint0"
  | "tint1"
  | "tint2"
  | "tint3"
  | "tint4"
  | "tint5"
  | "tint6"
  | "tint7"
  | "tint8"
  | "tint9"
  | "tint10"

/** @deprecated Use `HeadingProps` from `Heading` instead. */
export interface LegacyHeadingProps {
  color?: TextColor
  isUppercase?: boolean
  level: 1 | 2 | 3 | 4 | 5 | 6
  size?: 1 | 2 | 3 | 4 | 5 | 6
  text: string | React.ReactNode
}

const HEADING_SIZE_CLASSES = {
  1: "fs-0", // 24px
  2: "fs-21", // 21px
  3: "fs-2", // 18px
  4: "fs-3", // 16px
  5: "fs-4", // 14px
  6: "fs-5", // 12px
}

const getColorClasses = (color: LegacyHeadingProps["color"]) => `c-${color}`

const getFontSizeClasses = (
  level: LegacyHeadingProps["level"],
  size: LegacyHeadingProps["size"],
) => HEADING_SIZE_CLASSES[size || level]

/** @deprecated Use `Heading` instead. */
export const LegacyHeading = ({
  color = "tint0",
  isUppercase = false,
  level,
  size = undefined,
  text,
}: LegacyHeadingProps) => {
  const HeadingTag = `h${level}` as keyof JSX.IntrinsicElements

  return (
    <HeadingTag
      className={classnames(
        "lh-1.333",
        getColorClasses(color),
        getFontSizeClasses(level, size),
        isUppercase && "tt-u",
        "fw-600",
      )}
    >
      {text}
    </HeadingTag>
  )
}
